export const TOOLTIPS = {
  layout: {
    dashboard: { title: "Dashboard", placement: "right" },
    webActivityLogs: { title: "Web Activity Logs", placement: "right" },
    account: { title: "Account", placement: "right" },
    restore: { title: "Restore", placement: "right" },
    user_management: { title: "Users", placement: "right" },
    backupPlan: { title: "Backup Plan", placement: "right" },
    download_iso_builder: { title: "Download ISO builder", placement: "right" },
    virtualization: { title: "Virtualization", placement: "right" }
  },
  dashboard: {
    menu: { title: "Menu", placement: "right" },
    video: { title: "Watch Video", placement: "bottom" },
    back: { title: "Click to exit search", placement: "right" },
    showStats: { title: "Show Statistics", placement: "left" },
    hideStats: { title: "Hide Statistics", placement: "left" },
    groups: {
      deleteGroup: { title: "Delete", placement: "top" },
      renameGroup: { title: "Rename", placement: "top" },
      accordian_expand: { title: "Expand", placement: "bottom" },
      accordian_collapse: { title: "Collapse", placement: "bottom" }
    },
    searchClear: { title: "Clear Search", placement: "top" }
  },
  login: {
    passwordShow: { title: "Show", placement: "top" },
    passwordHide: { title: "Hide", placement: "top" }
  },
  backup: {
    editSettings: { title: "Edit Settings", placement: "top" },
    encryptionKey: { title: "Encryption Key", placement: "left" },
    pauseBackup: { title: "Pause Backup", placement: "top" },
    resumeBackup: { title: "Resume Backup", placement: "top" }
  },
  restore: {
    search: { title: "search", placement: "bottom" },
    clear: { title: "clear", placement: "bottom" },
    download: { title: "Download", placement: "bottom" },
    downloading: { title: "Downloading", placement: "bottom" },
    fileCheck: {
      title: "Select atleast one file or folder to restore.",
      placement: "top"
    },
    volumeCheck: {
      title: "Select atleast one volume to restore.",
      placement: "top"
    },
    updatedVolumes: {
      bootable: {
        title: "The boot drive cannot be selected",
        placement: "top"
      },
      size: {
        title:
          "The size of the selected disk is smaller than the disk to be restored",
        placement: "top"
      },
      selected: {
        title: "Disk is already selected",
        placement: "top"
      }
    },
    inProgress: { title: "Restore in Progress", placement: "top" },
    cancelRestore: { title: "Cancel Restore", placement: "top" },
    back: { title: "Back", placement: "bottom" }
  },
  logs: {
    download: { title: "Download", placement: "bottom" },
    downloading: { title: "Downloading", placement: "bottom" }
  },
  slidingPopup: {
    close: { title: "Close", placement: "left" },
    backup: { title: "Backup", placement: "left" },
    restore: { title: "Restore", placement: "left" },
    logs: { title: "Logs", placement: "left" },
    computerNameClose: { title: "Close", placement: "top" }
  },
  popUp: {
    close: { title: "Close", placement: "top" },
    back: { title: "Back", placement: "top" }
  },
  backupSettings: {
    back: { title: "Back", placement: "bottom" },
    edit: { title: "Edit", placement: "top" },
    cancel: { title: "Cancel", placement: "top" },
    encryptionKey: { title: "Encryption Key", placement: "top" },
    collapse: { title: "Collapse", placement: "top" },
    expand: { title: "Expand", placement: "top" },
    schedule: {
      interval: {
        title: "Set the desired interval between two consecutive backups",
        placement: "top"
      },
      cutOff: {
        title: "Set the time at which your on going Backup should stop.",
        placement: "top"
      },
      editInfo: {
        title:
          "Backup will commence within the selected time range depending on the server load",
        placement: "top"
      },
      backupStartTime: {
        title: "Set the time at which your scheduled backup should start.",
        placement: "top"
      }
    },
    email: {
      notification: {
        title:
          "Backup notifications will be sent to this email address. Use comma to add multiple email address",
        placement: "top"
      },
      addemail: {
        title:
          "Add recipient to receive backup notifications and click Save Changes",
        placement: "top"
      }
    },
    advanced: {
      cleanup: {
        title:
          "Cleanup permanently deletes data from your cloud account that no longer exist on your computer",
        placement: "top"
      }
    }
  },
  restoreSettings: {
    originalLocation: {
      title:
        "Your files will be restored to the same location from where they were backed up to the cloud",
      placement: "top"
    },
    customLocation: {
      title:
        "Choose or create a location on your computer where you want to restore files",
      placement: "top"
    },
    file: {
      home: { title: "Home", placement: "top" }
    },
    reload: { title: "Reload", placement: "right" }
  },
  virtualization: {
    dashboard: { title: "Lorem.", placement: "bottom" },
    maximumMemory: {
      title:
        "Displays the maximum memory that is available to build a virtual instance.",
      placement: "bottom"
    },
    networkSource: {
      title:
        "Choose how the VM should be attached to the network via the BMR Host.",
      placement: "bottom"
    },
    networkModel: {
      title: "Choose an appropriate virtual network adapter model.",
      placement: "bottom"
    },
    storageController: {
      title:
        "Choose an appropriate storage controller, which closely matches with the storage controller used on the physical machine.",
      placement: "bottom"
    },
    graphics: {
      title:
        "QXL is recommended for newer operating systems. Select VGA for older operating systems.",
      placement: "bottom"
    },
    attachISO: {
      title: "Attach a CD-ROM device to the VM.",
      placement: "bottom"
    },
    bootOrder: {
      title: "Select the first boot device.",
      placement: "bottom"
    },
    enableBootMenu: {
      title: "Enable BIOS boot menu during VM startup.",
      placement: "bottom"
    },
    rebuild: {
      title:
        "Unable to connect to virtual instance. Rebuild the instance and try again.",
      placement: "top"
    }
  },
  account: {
    cardCC: {
      title:
        "For Visa, MasterCard, and Discover cards, the CVC is the last 3 digit number printed on the back of the card on the signature panel, immediately after the card number. For an American Express card, it is the 4 digit number printed on the front of the card, above the card number.",
      placement: "top"
    }
  },
  users: {
    removeUser: {
      title: "Remove User",
      placement: "top"
    },
    resendInvitation: {
      title: "Resend Invitation",
      placement: "top"
    },
    copyInvitation: {
      title: "Copy Invitation",
      placement: "top"
    }
  },
  backupPlan: {
    settings: {
      default: {
        new: {
          title:
            "Create a customized plan for multiple computers and push it in one go. Select devices for backup, the backup source, schedule a backup, configure cleanup settings, email notifications, and apply the plan.",
          placement: "right"
        },
        update: {
          title:
            "Update the backup plan for multiple computers and push it in one go. Modify devices selected for backup, the backup source, backup schedule, cleanup settings, email notifications, and apply the updated plan.",
          placement: "right"
        }
      },
      edit: {
        title: "Edit",
        placement: "right"
      },
      addDevice: {
        title: "Select devices and customize a backup plan to secure them.",
        placement: "right"
      },
      addemail: {
        title: "Add recipient to receive backup notifications and click Done",
        placement: "top"
      }
    },
    status: {
      disabledMachine: {
        title: "Backup Plan is currently disabled",
        placement: "top"
      },
      disable: {
        title: "Disable plan",
        placement: "top"
      },
      enable: {
        title: "Enable plan",
        placement: "top"
      },
      delete: {
        title: "Delete plan",
        placement: "top"
      },
      propagate: {
        title: "Propagate plan",
        placement: "top"
      },
      edit: {
        title: "Edit plan",
        placement: "top"
      }
    }
  }
};

export const CONTENT = {
  dashboard: {
    filterBar: {
      addPC: "Add Computer",
      totalClients: "Number of computers:"
    },
    clientButtons: {
      enableNow: "Enable Now",
      backupNow: "Backup Now",
      restore: "Restore",
      cancel: "Cancel"
    },
    clientStatus: {
      newComputer: "Found a new computer! Enable backup to secure this computer"
    }
  },
  machineDetails: {
    os: "Operating system:",
    cpu: "CPU:",
    ram: "RAM:"
  },
  statuses: {
    backup: {
      safe: "Protected",
      error: "Not Protected",
      success: "Backup Success",
      failed: "Backup Failed",
      cancelled: "Backup Canceled",
      progress: "Backed up",
      inProgress: "Backing up",
      paused: "Backup Paused",
      new: "New"
    },
    restore: {
      success: "Restore Success",
      failed: "Restore Failed",
      cancelled: "Restore Canceled",
      progress: "Restoring"
    }
  },
  statusMsgs: {
    backup: "Backup in progress",
    backupPaused: "Backup is paused",
    restore: "Drive restore is currently in progress",
    failedNoDrives: "Failed to detect the drive",
    viewDetails: "View Details",
    backupRestoreBoth: "Backup and Restore are currently in progress",
    backupPausedRestoreProgress: "Backup is paused and Restore is in progress"
  },
  progressStatuses: {
    waiting: "Queued",
    inProgress: "In progress",
    paused: "Paused"
  },
  restore: {
    dashboard: {
      noMachine: "No Computers to Restore"
    },
    recoveryPoint: {
      version: "Backup Version",
      choose: "Choose recovery point",
      noPoint: "No backup point"
    },
    file: {
      volumesList: "Local Disk ",
      noCustomSelection: "No folder selected",
      alreadyExit: "Folder with same name already exists."
    },
    image: {
      volumesList: "Local Disk ",
      updatedVolumesList: "Local Disk "
    }
  },
  backupSettings: {
    encryptionWarning: [
      "Once you set the encryption key (default or private), you will not be able to change this key in future",
      "Mirror Backup does not store your private encryption key on its servers and therefore, will not be able to provide this information. A special technique to encrypt your private encryption key is used only to verify but not to retrieve it.",
      "Without your private encryption key, you will not be able to retrieve your data; therefore, it is highly recommended that you archive this information safely."
    ],
    encryption: {
      DEFAULT_ENCRYPTION: {
        title: "Default Encryption Key",
        brief:
          "Mirror Backup will set an encryption key to encrypt all your data."
      },
      CUSTOMISED_ENCRYPTION: {
        title: "Private Encryption Key",
        brief:
          "Set your own private encryption key to encrypt all your data. On setting this option, you will not be able to share files/folders."
      },
      key: {
        value: "Set your encryption key:",
        confirmValue: "Confirm your encryption key:"
      }
    },
    backupSchedule: {
      advance: {
        startBackupImmediately: "Start backup immediately",
        hibernate: "Prevent the computer from going to Hibernate / Sleep mode",
        notifyOnDesktop: "Notify me on desktop",
        shutdown: "Shut down the computer when the backup is complete",
        startup:
          "Start the missed scheduled backup when the computer is turned on",
        wakeup: "Wake up the computer from Hibernate / Sleep mode for backup",
        creds: {
          username: "Windows username",
          pwd: "Password"
        }
      }
    },
    advance: {
      cleanup: {
        automatically: {
          part1: "Automatically perform cleanup after every",
          part2: "incremental backup"
        },
        delete: {
          part1: "Delete versions that are older than",
          part2: "months"
        }
      },
      performance: {
        backupPriority: {
          part1: "Backup Priority",
          part2: "High priority is recommended for ensuring fast backup"
        },
        networkSpeed: {
          part1: "Network Speed",
          part2:
            "Unrestricted network access is recommended for ensuring fast backup"
        }
      },
      skipDiskErr: {
        checkLabel: "Ignore bad sectors",
        checkNote:
          "Corrupted sectors on source disks will be skipped during backup."
      }
    },
    eNotification: {
      send: "Send email notification"
    },
    sourceType: {
      "entire-pc": "Entire PC",
      customize: "Custom"
    },
    buttons: {
      save: "Save Changes",
      cancel: "Cancel"
    }
  },
  virtualization: {
    loaderMessages: {
      powerOffVm: "Powering off virtual machine ",
      powerOnVm: "Preparing virtual machine for ",
      deleteVm: "Deleting virtual machine "
    }
  },
  welcomePage: {
    header1: {
      title: {
        mirror: "Welcome to IDrive<sup>®</sup> Mirror",
        ibackup: "Welcome to IBackup<sup>®</sup> Mirror"
      },
      content:
        "Backup your entire computer including the operating system, installed programs, system settings, directly to the IDrive cloud. Maintain bare-metal restore capability with image-based backup"
    },
    header2: {
      title: "Getting Started",
      content: "Perform full image backup to the cloud in 3 easy steps"
    }
  },
  appLogs: {
    backup: {
      success: "Computer backed up",
      failed: "Computer backup failed",
      stopped: "Backup has been canceled",
      paused: "Backup is paused due to the specified cut-off time"
    },
    restore: {
      fileRestore: {
        ui: {
          success: "File downloaded",
          failure: "File download failed",
          stopped: "File download stopped"
        },
        client: {
          success: {
            originalLocation: "Files recovered to original location",
            customLocation: "File restored to the selected location",
            computer: "Files restored to computer"
          },
          failure: "File restore has failed",
          stopped: "File restore has been canceled"
        }
      },
      volumeRestore: {
        success: {
          originalLocation: "Computer has been restored (volumes)",
          computer: "Disk image restored to computer"
        },
        failure: "Image restore has failed",
        stopped: "Image restore has been canceled"
      },
      imageRestore: {
        success: {
          originalLocation: "Computer has been restored (volumes)",
          computer: "Disk image restored to computer"
        },
        failure: "Image restore has failed",
        stopped: "Image restore has been canceled"
      }
    },
    backupSettings: {
      schedule: "Schedule settings updated - ",
      scheduleAdvanced: "Schedule settings updated - Advanced settings changed",
      cutOffTime: "Cutoff time updated",
      scheduleMiscellaneous:
        "Schedule settings updated - Multiple properties changed",
      email: "Backup email notification - ",
      emailAdded: "added",
      emailRemoved: "removed",
      smtp: "Backup email notification - SMTP settings changed",
      enableDisableNotification: "Backup notification settings changed",
      emailMultiple: "Backup email notification - Multiple properties changed",
      source: "Backup source changed - ",
      encryption: "Schedule encryption settings",
      advanced: "Backup advanced settings - ",
      emailNotification: "Backup notification settings changed",
      newConfigured: "New computer configured",
      scheduleMultiple: "Multiple Schedule settings changed.",
      computerName: "Computer name changed to "
    },
    backupPlan: {
      added: "Machine added to the backup plan - ",
      removed: "Machine removed from the backup plan - ",
      settingsChanged:
        "Backup settings changed for this machine under backup plan - ",
      enabled: "Backup plan for the machine is enabled under - ",
      disabled: "Backup plan for the machine is disabled under - ",
      deleted: "Machine associated to the backup plan - "
    }
  },
  signup: {
    leftShelf: {
      header: "Cloud-based image backup for your PCs and Windows servers",
      headerContent:
        "Backup your entire system directly to the secure IDrive cloud via web",
      features: [
        {
          title: "Disk Imaging",
          class: "cmi",
          link: "https://www.idrivemirror.com/faq_backup#backup-computers",
          desc:
            "Perform image-based backup of your computer with bare metal restore capacity"
        },
        {
          title: "Snapshot-based Recovery",
          class: "voc",
          link: "https://www.idrivemirror.com/faq_restore#snapshot-based",
          desc:
            "Save previous versions of your backup for point-in-time recovery"
        },
        {
          title: "System Image Restore",
          class: "qsir",
          link: "https://www.idrivemirror.com/faq_restore#restore-media",
          desc:
            "Restore entire computer whenever necessary, without time-consuming OS installation"
        }
      ]
    },
    rightShelf: {
      emptyField: "The field cannot be blank.",
      invalidEmail: "Enter a valid email.",
      shortPassword: "Password too short."
    },
    updatePassword: {
      passwordMismatch: "Entered passwords dont match.",
      updatedSuccess: "Your password has been successfully updated.",
      linkExpired: "The password reset link has expired.",
      subUserLinkExpired: "The sub-user account creation link has expired"
    },
    cancelAccount: {
      updatedSuccess:
        "Your IDrive Mirror account has been canceled as per your request."
    },
    cancelledAccount: {
      updatedSuccess:
        "This account has been canceled on your request. <a href='https://www.idrivemirror.com/support'>Contact support</a>."
    },
    blockedAccount: {
      updatedSuccess: "Your account is blocked. Please contact administrator"
    },
    sessionAlreadyExists: {
      updatedSuccess:
        "One IDrive Mirror account is already logged in. Please reload this page"
    },
    metaDescription: {
      login:
        "Login to IDrive Mirror and protect your Windows computers and server systems including any virtual instances against data loss and ransomware",
      signup:
        "Sign up to IDrive Mirror and protect your Windows computers and server systems including any virtual instances against data loss and ransomware",
      freePlan:
        "Sign up for an IDrive® Mirror Free account. Get started with your PC protection and explore Mirror features",
      personalPlan:
        "Sign up for an IDrive Mirror Personal account. Get up to 5 TB storage for unlimited PC protection against ransomware",
      teamPlan:
        "Sign up for an IDrive Mirror Team account. Add multiple users to your account and get unlimited PC protection against ransomware"
    }
  },
  logoff: {
    savelogs: "Logged out successfully"
  },
  productName: {
    mirror: "MirrorWindows",
    ibackup: "IBackupMirrorWindows"
  }
};

export const EMPTY = {
  dashboard: {
    noMachines: {
      class: "add_computer_wrap",
      url: process.env.REACT_APP_STATIC_URL + "/images/add-computer.png",
      alt: "backup_empty",
      title: "No computers to display",
      pClass: "add_computer_title"
    },
    noSearch: {
      class: "backup_search_empty",
      url: process.env.REACT_APP_STATIC_URL + "/images/search_results.png",
      alt: "search_result",
      title: "Sorry, no results found!"
    }
  },
  restore: {
    noMachines: {
      class: "restore_empty_screen",
      url: process.env.REACT_APP_STATIC_URL + "/images/restore-main-icon.png",
      alt: "empty-screen",
      title: "No Computers to Restore"
    },
    noSearch: {
      class: "backup_search_empty",
      url: process.env.REACT_APP_STATIC_URL + "/images/search_results.png",
      alt: "search_result",
      title: "Sorry, no results found!"
    }
  },
  fileRestore: {
    noRecoveryPoint: {
      class: "restore_empty_screen",
      url: process.env.REACT_APP_STATIC_URL + "/images/empty-host.png",
      alt: "no_recovery_point",
      title: "No backup available for restore"
    },
    folder: {
      class: "restore_empty_screen",
      url: process.env.REACT_APP_STATIC_URL + "/images/empty-host.png",
      alt: "folder_emppty",
      title: "This folder is empty"
    },
    search: {
      class: "restore_empty_screen",
      url: process.env.REACT_APP_STATIC_URL + "/images/search_results.png",
      alt: "search_result",
      title: "No results found for"
    }
  },
  imageRestore: {
    offline: {
      class: "restore_empty_screen",
      url: process.env.REACT_APP_STATIC_URL + "/images/empty-host.png",
      alt: "no_recovery_point",
      title: "Machine is offline"
    },
    noRecoveryPoint: {
      class: "restore_empty_screen",
      url: process.env.REACT_APP_STATIC_URL + "/images/empty-host.png",
      alt: "no_recovery_point",
      title: "Restore volumes are not available."
    }
  }
};

export const VALIDATION = {
  backupSettings: {
    init: { status: true, msg: "", params: {} },
    source: {
      emptyVolumes: "Please Select atleast one volume"
    },
    email: {
      valid: "Enter a valid email address",
      duplicate: "Email already exist",
      error: "Error",
      default: "Email address cannot be blank",
      long: "Email is too long"
    },
    smtp: {
      username: "Should be atleast 3 characters.",
      port: "Port should be in the range 1-65535.",
      password: "Should be atleast 4 characters.",
      servername: "Should be atleast 3 characters."
    },
    schedule: {
      emptyWeekdays: "Please select at least one day.",
      emptyMonths: "Please select at least one month and one day.",
      validDates:
        "Please select at least one valid date for each selected month.",
      emptyPassword: "Please enter password.",
      minimumPassword: "Password need to be minimum 6 characters",
      emptyUserName: "Please enter email address."
    }
  },
  auth: {
    agreeTerms:
      "You must agree to the terms of IDrive Mirror service for account creation",
    samePassword: "New password cannot be same as your old password"
  },
  formFields: {
    email: "Enter a valid email address",
    password: {
      minLength: "Password must contain at least 6 characters",
      match: "Password and Confirm Password must match"
    },
    firstName: "First name can only contain a-z and A-Z",
    lastName: "Last name can only contain a-z and A-Z",
    phone: "Enter a valid phone number",
    blank: {
      email: "Email cannot be blank",
      password: "Password cannot be blank",
      firstName: "First name cannot be blank",
      lastName: "Last name cannot be blank",
      phone: "Phone Number cannot be blank",
      reason: "Please select a reason for account cancellation",
      currentPassword: "Current password cannot be blank",
      newPassword: "New password cannot be blank",
      confirm: "Confirm password cannot be blank"
    },

    default: "This field cannot be blank"
  },
  groups: {
    nameExists: "Group name already exists",
    empty: "Group name cannot be empty",
    max: "Group name cannot exceed 20 characters",
    specialChars: "Group name can contain only a-z, A-Z, 0-9, _and-."
  }
};

export const NOTIFICATIONS = {
  backup: {
    initiateBackup: "Initiating backup...",
    cancelBackup: "Stopping backup...",
    snapShot: {
      1: "Creating your system snapshot. Wait while it completes.",
      2: "Gathering disk information",
      3: "Connecting to the server",
      4: "Preparing to take snapshot"
    }
  },
  restore: {
    initiateRestore: "Initializing Restore...",
    fileCheck: "Select atleast one file or folder to restore.",
    offline:
      "Selected target computer is offline now. Please select machine which is online for restore",
    backupInProgress:
      "Restore can not be performed as backup for machine %CLIENT_NAME% is currently in progress ",
    restoreInProgress:
      "Restore is in progress for the machine %CLIENT_NAME%. Please visit dashboard to check the progress.",
    cancelRestore: "Stopping restore...",
    cancelled: "Restore stopped",
    searchLimit:
      "Too many results found. Refine your search with specific keywords.",
    preparingImageRestore: "Preparing Restore for volume - ",
    fileSizeGreaterThan: "Download file size is restricted to 10 Gb.",
    unableToDownload: "Unable to download the file.",
    customLocation: "Select a custom location for restore.",
    restoreStopped: "Restore stopped"
  },
  imageRestore: {
    targetVolume: "Select the target volume",
    volumeCheck: "Select atleast one volume to restore.",
    initiateImageRestore: "Initializing Image Restore..."
  },
  backupSettings: {
    success: "Settings have been updated",
    failure: "Settings could not be updated"
  },
  enableMachine: {
    success: "Machine has been configured",
    failure: "Machine could not be configured",
    computerLimit:
      "You have reached the maximum permissible limit for adding machines. Upgrade plan to add more computers."
  },
  removeMachine: {
    success: "Successfully Removed the Machine!",
    failure: "Failed to Remove the Machine ;)"
  },
  account: {
    profile: {
      success: "Account details have been updated",
      failure: "Account details could not be updated"
    },
    plan: {
      expiry:
        "Your free trial has expired. You cannot perform any new backup. However, you can restore your backed up data.",
      ccfailureAccount:
        "There was an error in your payment details, please update your payment details in account page"
    },
    passwordUpdate: {
      success: "Password has been updated",
      failure: "Password could not be updated"
    },
    reEnterPassword: {
      failure: "Invalid Password"
    },
    upgradePlan: {
      success: "Successfully upgraded the plan",
      failure: "Payment failed."
    },
    updateCreditCard: {
      success: "Credit card updated successfully",
      failure: "Credit card update failed"
    },
    applyPendingCharges: {
      success: "Pending charges applied successfully",
      failure:
        "Unable to apply pending charges. Please check the details entered and try again."
    }
  },
  server: {
    noResponse: "Unable to reach the server",
    pnsDown:
      "We are trying to connect to your machines. You will not be able to start any backups till then."
  },
  logs: {
    unableToDownload: "Unable to download the file."
  },
  auth: {
    emailExists:
      "Email address already in use. Enter a different email address.",
    resetPassword:
      "If your email exists in our system, you will receive an email with instructions to reset the password."
  },
  users: {
    invite: {
      resendInviteSuccess: "Invitation sent successfully.",
      resendInviteFailed: "Invitation failed to send."
    },
    clipboard: "Invite copied to clipboard.",
    removeSubuser: {
      failed: "Something went wrong. Unable to remove user.",
      success: "User removed successfully."
    },
    cancelInvite: {
      failed: "Something went wrong. Unable to cancel user invite.",
      success: "User invite canceled."
    }
  },
  backupPlan: {
    settings: {
      success: "Backup plan updated successfully.",
      failure: "Something went wrong. Unable to update the settings."
    },
    enable: {
      enableSuccess: "Selected backup plan(s) have been enabled",
      enableFailed: "error"
    },
    disable: {
      disableSuccess: "Selected backup plan(s) have been disabled",
      disableFailed: "error"
    },
    delete: {
      deleteSuccess: "Selected backup plan(s) have been deleted",
      deleteFailed: "error"
    },
    createNew: {
      success: "Backup plan created successfully",
      failure: "Something went wrong. Unable to create the plan."
    }
  },
  dashboardGroups: {
    addClientsToGroup: {
      success: "Selected devices(s) have been added to the group.",
      failure: "Something went wrong. Unable to add machine(s) to the group."
    },
    renameGroupName: {
      success: "Group name changed successfully",
      failure: "Group name could not be changed"
    },
    createNewGroup: {
      success: "Device group has been created successfully",
      failure: "Device group could not be created"
    },
    deleteGroup: {
      success: "Device group has been deleted successfully",
      failure: "Device group could not be deleted"
    },
    removeMachineFromGroup: {
      success: "Selected device(s) have been removed from the group ",
      failure: "Something went wrong. Unable to remove from the group"
    }
  },
  virtualization: {
    createVMTask: {
      success:
        "Task to create the virtual instance has been created. Your virtual instance will be ready to use shortly.",
      failure: "Failed to create virtual instance. Try again."
    },
    buildVm: {
      success: "Virtual instance is ready to access.",
      failure: "Failed to create virtual instance. Try again."
    },
    reconfigure: {
      success: "Virtual instance configuration is updated.",
      failure:
        "Unable to update Virtual instance configuration. Try again later."
    },
    controlVM: {
      success: "Success",
      failure: "Unable to perform operation. Try again."
    },
    deleteVM: {
      success: "Virtual instance is deleted.",
      failure: "Unable to delete virtual instance. Try again."
    },
    oneClickVirtualization: {
      initVirtualization: "Verifying pre-requisites...",
      fetchRecoveryPoints: "Fetching latest recovery point...",
      failure: {
        ramExceed: "Unable to create virtual instance due to insufficient RAM.",
        vmExists:
          "A virtual instance already exists for this machine. Access it from Virtualization tab.",
        machinesLimit:
          "You can build upto 4 virtual instances. Delete an existing virtual instance to build more.",
        recoveryPointNotExists:
          "Unable to virtualize as no backup found for boot volume (C:).",
        noLastBackup:
          "Unable to virtualize as no backups found for this machine"
      }
    }
  }
};

export const HELPERS = {
  withRouter: ["history", "location", "match", "staticContext"],
  slidingPopup: { searchResult: "Search Results" }
};

export const CLIENT_ERROR_MSGS = {
  // network issue errors
  SOCKET_TIMEOUT:
    "Request failed due to network issues. Verify the connection.",
  SOCKET_START_ERROR:
    "Request failed due to network issues. Verify the connection.",
  SOCKET_SEND_ERROR:
    "Request failed due to network issues. Verify the connection.",
  SOCKET_ACK_ERROR:
    "Request failed due to network issues. Verify the connection.",
  SOCKET_WRITE_ERROR:
    "Request failed due to network issues. Verify the connection.",
  SOCKET_READ_ERROR:
    "Request failed due to network issues. Verify the connection.",
  SOCKET_CLOSED: "Request failed due to network issues. Verify the connection.",
  RETRY_PACKET: "Request failed due to network issues. Verify the connection.",
  NETWORK_CLOSED_ERROR:
    "Request failed due to network issues. Verify the connection.",
  OPENSSL_ERROR: "Request failed due to network issues. Verify the connection.",
  // server issue errors
  SERVER_UNKNOWN_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  ZFS_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  BLOCK_DECOMPRESSION_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  PROTOCOL_PROCESSING_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  INCORRECT_MODULE_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  PACKET_FRAGMENT_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  BACKUP_INTEGRITY_ERROR:
    "Request failed due to a local system or server issue. Retry or contact support.",
  BACKUP_SET_NOT_EXIST:
    "Request failed due to a local system or server issue. Retry or contact support.",
  SMTP_DETAILS_NOT_FOUND:
    "Request failed due to a local system or server issue. Retry or contact support.",
  DATA_CATALOG_NOT_EXIST:
    "Request failed due to a local system or server issue. Retry or contact support.",
  BACKUP_SCHEDULE_DOES_NOT_EXIST:
    "Request failed due to a local system or server issue. Retry or contact support.",
  MOUNT_CHECK_FAILED:
    "Request failed due to a local system or server issue. Retry or contact support.",
  VOLUME_CHECKSUM_NOT_EXIST:
    "Request failed due to a local system or server issue. Retry or contact support.",
  FAILED_OLD_BACKUP:
    "Request failed due to a local system or server issue. Retry or contact support.",
  // bitmap and volume errors
  DISK_SEEK_ERROR: "Request failed due to disk issues. Verify disk and retry.",
  DISK_CREATION_ERROR:
    "Request failed due to disk issues. Verify disk and retry.",
  DISK_WRITE_ERROR: "Request failed due to disk issues. Verify disk and retry.",
  DISK_READ_ERROR: "Request failed due to disk issues. Verify disk and retry.",
  INVALID_DISK_HANDLE_ERROR:
    "Request failed due to disk issues. Verify disk and retry.",
  DISK_DETAILS_MISMATCH:
    "Request failed due to disk issues. Verify disk and retry.",
  CLIENT_UNREGISTERED:
    "Request could not be completed as the client is not registered to the server",
  VOLUME_NOT_CONFIGURED: "Request failed. Volume is not accessible.",
  BLOCK_READ_ERROR: "Request failed. Volume is not accessible.",
  VOLUME_SERIAL_EMPTY: "Request failed. Volume is not accessible.",
  MBR_READ_ERROR: "Request failed. Volume is not accessible.",
  BLOCK_PROCESS_ERROR: "Request failed. Volume is not accessible.",
  BLOCK_READ_CRC_ERROR: "Request failed. Volume is not accessible.",
  FILESYSTEM_ERROR: "Request failed. Volume is not accessible.",
  VOLUMES_NOT_UPDATED:
    "Request failed. Volumes could not be updated. / Error in one of the backup volumes. Contact support.",
  BITMAP_CREATION_ERROR:
    "Backup initiation failed: unable to access required volumes or drives.",
  CLIENT_BITMAP_NOT_EXIST:
    "Backup initiation failed: unable to access required volumes or drives.",
  CLIENT_BITMAP_NOT_CREATED:
    "Backup initiation failed: unable to access required volumes or drives.",
  CLIENT_BITMAP_READ_ERROR:
    "Backup initiation failed: unable to access required volumes or drives.",
  CLIENT_BITMAP_WRITE_ERROR:
    "Backup initiation failed: unable to access required volumes or drives.",
  BITMAP_WRITE_ERROR:
    "Backup initiation failed: unable to access required volumes or drives.",
  // data and backup errors
  ALLOCATED_SPACE_EXEED_ERROR: "Allocated space exceeded",
  EMAILS_NOT_CONFIGURED: "Email settings not configured",
  VOLUME_SERIAL_NUMBER_MISMATCH:
    "Backup failed due to a configuration issue. Contact support.",
  // operation status errors
  BACKUP_PAUSED: "Backup paused. Try again after sometime.",
  HARD_CUTOFF_TIME_SET: "Backup cutoff time reached",
  // client errors
  SNAPSHOT_ERROR: "Snapshot error occurred",
  SNAPSHOT_READ_ERROR:
    "Failed to read from snapshot. Retry or contact support.",
  SNAPSHOT_DELETED: "Snapshot deleted",
  INSUFFICIENT_SPACE_FOR_SNAPSHOT:
    "Insufficient space for snapshot / Insufficient local disk space for snapshot creation. Clear space and retry.",
  SNAPSHOT_ERROR_ACCESS_DENIED:
    "Snapshot access denied / Snapshot creation failed due to drive access denied.",
  SNAPSHOT_ERROR_OBJECT_NOT_FOUND: "Snapshot object not found",
  SNAPSHOT_PROVIDER_ERROR: "Snapshot provider error occurred. Contact support.",
  SNAPSHOT_IN_PROGRESS_ERROR: "Snapshot already in progress",
  SNAPSHOT_MAXIMUM_NUMBER_OF_VOLUMES_REACHED:
    "Maximum number of volumes reached",
  SNAPSHOT_MAXIMUM_NUMBER_OF_SNAPSHOTS_REACHED:
    "Maximum number of snapshots reached",
  SNAPSHOT_PROVIDER_NOT_REGISTERED: "Snapshot provider not registered",
  SNPASHOT_VOLUME_NOT_SUPPORTED: "Snapshot volume type not supported",
  HASH_FILE_ERROR:
    "Request failed due to an internal backup set error. Contact support.",
  BACKUPSET_UUID_ERROR:
    "Request failed due to an internal backup set error. Contact support.",
  // client and data processing errors
  CLIENT_UNKNOWN_ERROR: "System error occurred during backup. Contact support.",
  NO_VOLUMES_SELECTED: "No volumes selected for backup",
  ACCOUNT_EXPIRED: "Account expired",
  ACCOUNT_UNDER_MAINTENANCE: "This Account is under maintenance.",
  ACCOUNT_CANCELLED: "Account canceled",
  ACCOUNT_VALIDATION_ERROR: "Account validation failed. Contact support.",
  BACKUP_CANCELED: "Backup canceled",
  BACKUPSET_CHANGED: "Unable to continue because the backup set has changed.",
  WINDOWS_UPDATE_NEEDS_RESTART: "Windows update restart pending",
  // restore errors
  RESTORE_PATH_ERROR: "Invalid restore path",
  FOLDER_CREATION_ERROR: "Failed to create folder during restore",
  FILE_CREATION_ERROR: "Failed to create file during restore",
  FILE_WRITE_ERROR: "Failed to write file during restore",
  FILE_SIZE_MISMATCH:
    "Restore failed due to file size mismatch. Retry or contact support.",
  FILE_SIZE_EXCEED: "File size exceeded limit",
  DATA_LENGTH_ERROR: "Restore failed. Retry or contact support.",
  INVALID_VOLUME_INFO_ERROR: "Restore failed. Retry or contact support.",
  VOLUME_DATA_ERROR: "Restore failed. Retry or contact support.",
  CLIENT_HASH_READ_ERROR: "Restore failed. Retry or contact support.",
  JSON_VOLUME_INFO_ERROR: "Restore failed. Retry or contact support.",
  DIRECTORY_CREATION_ERROR: "Restore failed. Retry or contact support.",
  RESTORE_LOGGING_ERROR: "Restore failed. Retry or contact support.",
  JSON_INVALID_ERROR: "Restore failed. Retry or contact support.",
  SKIP_FILE_RESTORE: "Restore failed. Retry or contact support.",
  // miscellaneous errors
  STORAGE_ERROR:
    "Request could not be completed as system encountered storage error",
  FULL_BACKUP_NOT_EXIST:
    "System encountered an error as full backup does not exist on the server",
  RESTORE_JOB_NOT_EXIST:
    "System encountered an error as restore job could not be found in the server",
  FILE_RESTORE_MAX_RETRY_EXCEEDED:
    "Unable to restore the files at this time. Check your internet connection or try again later.",
  SELECT_ATLEAST_ONE_VOLUME: "Please select at least one volume",
  BACKUP_PAUSED_CUTOFF_REACHED:
    "Backup is paused due to the specified cut-off time. You can start the backup manually or it will resume at the scheduled time",
  MACHINE_NAME_CAN_NOT_BE_EMPTY:
    "Machine name can not be empty. Please enter a name.",
  default:
    "System encountered an error and was unable to complete your request. Try again."
};

//Return the icon CSS class based on file extension
export const FILE_ICON_TYPE = {
  png: { class: "frt_img", type: "PNG File" },
  jpg: { class: "frt_img", type: "JPG File" },
  jpeg: { class: "frt_img", type: "JPEG File" },
  gif: { class: "frt_img", type: "GIF File" },
  doc: { class: "frt_word", type: "Word File" },
  docx: { class: "frt_word", type: "Word File" },
  pdf: { class: "frt_pdf", type: "PDF File" },
  disk: { class: "frt_disk", type: "Local Drive" },
  directory: { class: "frt_folder", type: "File Folder" },
  default: { class: "frt_default", type: "Undefined Document" },
  txt: { class: "frt_txt", type: "Text Document" },
  log: { class: "frt_txt", type: "Text Document" },
  zip: { class: "frt_zip", type: "ZIP Document" },
  rar: { class: "frt_zip", type: "RAR Document" },
  arc: { class: "frt_zip", type: "ARC Document" },
  arj: { class: "frt_zip", type: "ARJ Document" },
  bz2: { class: "frt_zip", type: "BZ2 Document" },
  daa: { class: "frt_zip", type: "DAA Document" },
  gz: { class: "frt_zip", type: "GZ Document" },
  tar: { class: "frt_zip", type: "TAR Document" },
  zim: { class: "frt_zip", type: "ZIM Document" },
  "7z": { class: "frt_zip", type: "7Z Document" },
  mp3: { class: "frt_music", type: "MP3 Audio File" },
  wav: { class: "frt_music", type: "WAV File" },
  aac: { class: "frt_music", type: "AAC File" },
  ogg: { class: "frt_music", type: "Ogg Vorbis Audio File" },
  wma: { class: "frt_music", type: "WMA File" },
  mp4: { class: "frt_video", type: "MPEG4 Video File" },
  m4a: { class: "frt_video", type: "MPEG 4 Audi File" },
  m4v: { class: "frt_video", type: "Apple MP4 Video File" },
  mov: { class: "frt_video", type: "Apple QuickTime Movie File" },
  wmv: { class: "frt_video", type: "Windows Media Video File" },
  webm: { class: "frt_video", type: "WEB Media File" },
  flv: { class: "frt_video", type: "Adobe Flash File" },
  avi: { class: "frt_video", type: "AVI File" },
  WAV: { class: "frt_video", type: "WAV File" },
  VOB: { class: "frt_video", type: "DVD Video Object" },
  xlsx: { class: "frt_excel", type: "Excel File" },
  xls: { class: "frt_excel", type: "Excel File" },
  csv: { class: "frt_csv", type: "CSV File" },
  exe: { class: "frt_exe", type: "Application" },
  lib: { class: "frt_lib", type: "Library File" },
  json: { class: "frt_json", type: "JSON File" },
  rdp: { class: "frt_rdp", type: "Remote Desktop File" },
  cmake: { class: "frt_cmake", type: "CMake File" },
  bin: { class: "frt_bin", type: "Binary File" },
  dll: { class: "frt_dll", type: "DLL File" },
  exp: { class: "frt_exp", type: "EXP File" },
  msi: { class: "frt_msi", type: "MSI File" },
  config: { class: "frt_config", type: "Config File" },
  ppt: { class: "frt_ppt", type: "PowerPoint File" },
  dat: { class: "frt_dat", type: "DAT File" },
  iso: { class: "frt_iso", type: "ISO File" },
  db: { class: "frt_db", type: "Database File" },
  ini: { class: "frt_ini", type: "INI File" }
};

export const STATIC_VARIABLES = {
  breadcrumbDropdown: 8,
  maxTrottleSpeed: 999 * 1000 * 1000
};

export const STYLE_SHEETS = {
  login:
    process.env.REACT_APP_STATIC_URL +
    "/css/login-signup-v2.css?v=" +
    process.env.REACT_APP_VERSION,
  switch:
    process.env.REACT_APP_STATIC_URL +
    "/css/switch_style.css?v=" +
    process.env.REACT_APP_VERSION,
  styles:
    process.env.REACT_APP_STATIC_URL +
    "/css/styles-v2.css?v=" +
    process.env.REACT_APP_VERSION,
  responsiveStyles:
    process.env.REACT_APP_STATIC_URL +
    "/css/responsive_styles-v2.css?v=" +
    process.env.REACT_APP_VERSION,
  restoreCSS:
    process.env.REACT_APP_STATIC_URL +
    "/css/restore-css-v2?v=" +
    process.env.REACT_APP_VERSION,
  subUserCSS:
    process.env.REACT_APP_STATIC_URL +
    "/css/user-v2.css?v=" +
    process.env.REACT_APP_VERSION,
  backupPlanCSS:
    process.env.REACT_APP_STATIC_URL +
    "/css/backup_plan.css?v=" +
    process.env.REACT_APP_VERSION,
  pdfTemplateCSS:
    process.env.REACT_APP_STATIC_URL +
    "/css/pdf_template.css?v=" +
    process.env.REACT_APP_VERSION,
  virtualizationCSS:
    process.env.REACT_APP_STATIC_URL +
    "/css/virtualization.css?v=" +
    process.env.REACT_APP_VERSION,
  virtualization_dashboard:
    process.env.REACT_APP_STATIC_URL +
    "/css/dashboard_virtual_v1.css?v=" +
    process.env.REACT_APP_VERSION
};

export const HTTP_EXCEPTION_MESSAGES = {
  BACKUP_INTEGRITY_ISSUE:
    "A data integrity check needs to be performed for the selected recovery point.",
  CLIENT_QUOTA_EXCEEDED:
    "You have reached the maximum permissible limit for adding machines. Upgrade plan to add more computers.",
  DB_ERROR:
    "The server encountered an unexpected error establishing a database connection.",
  DEFAULT_SETTINGS_JSON_ERROR:
    "The server encountered an unexpected error while fetching Default Settings JSON.",
  EXTERNAL_SERVER_CONNECT_EXCEPTION:
    "Unable to connect as client server is not available.",
  MULTIPLE_FILE_RESTORE_RESTRICTED:
    "Downloading multiple files or folders is restricted.",
  PARAMETER_MISSING: "The required parameter is missing in the API request.",
  REQUEST_JSON_ERROR: "Irregular JSON received by the API Server.",
  RESOURCE_NOT_FOUND: "Failed to find the resource.",
  RESOURCE_PRE_EXIST: "Resource already exists.",
  RESTORE_IN_PROGRESS: "Restore is in progress for the backed up computer.",
  BACKUP_IN_PROGRESS: "Backup is in progress for the computer",
  RESTORE_LOCATION_INACCESSIBLE:
    "The restore location is inaccessible. Contact support.",
  RESTORE_ZIP_ERROR:
    "There was an issue while trying to zip the restored file or folder.",
  UNKNOWN_ERROR: "The API server encountered an unknown error.",
  VIRTUAL_INSTANCE_EXIST:
    "A virtual instance for the selected machine already exists. Try using another machine.",
  WEBSERVER_EXCEPTION: "The web server encountered an unexpected error."
};

export const RESTORE_PATH_EXCEPTIONS = {
  ownMachine: [
    "C:\\$Recycle.Bin",
    "C:\\Program Files",
    "C:\\Program Files (x86)",
    "C:\\ProgramData\\IDrive Mirror",
    "C:\\Windows",
    "C:\\BOOTNXT",
    "C:\\bootmgr",
    "C:\\System Volume Information",
    "C:\\swapfile.sys",
    "C:\\hiberfil.sys",
    "C:\\pagefile.sys",
    "C:\\BOOTNXT",
    "C:\\bootmgr",
    "C:\\Recovery"
  ],
  otherMachine: [
    "C:\\$Recycle.Bin",
    "C:\\Program Files",
    "C:\\Program Files (x86)",
    "C:\\ProgramData",
    "C:\\Users",
    "C:\\Windows",
    "C:\\BOOTNXT",
    "C:\\bootmgr",
    "C:\\System Volume Information",
    "C:\\Documents and Settings",
    "C:\\swapfile.sys",
    "C:\\hiberfil.sys",
    "C:\\pagefile.sys",
    "C:\\BOOTNXT",
    "C:\\bootmgr",
    "C:\\Recovery"
  ]
};

export const DEFAULT_COUNTRY_CODE = "+1 (USA)";

export const STATIC_URLS = {
  logo: {
    mirror: {
      url: "/images/mirror_logo.svg",
      alt: "mirror_logo"
    },
    ibackup: {
      url: "/images/ibackup_mirror_logo.svg",
      alt: "ibackup_logo"
    }
  },
  home: {
    mirror: "https://www.idrivemirror.com/",
    ibackup: "https://www.ibackup.com/image-backup/",
    idrive: "https://www.idrive.com/mirror-image-backup"
  },
  // features: {
  //   mirror: "https://www.idrivemirror.com/idrive-mirror-features",
  //   ibackup: "#"
  // },
  support: {
    mirror: "https://www.idrivemirror.com/support",
    ibackup: "#",
    idrive: "https://www.idrive.com/support"
  },
  faqs: {
    mirror: "https://www.idrivemirror.com/faq",
    ibackup: "#",
    idrive: "https://www.idrive.com/mirror-image-backup-faq"
  },
  virtualisationFaq: {
    mirror: "https://www.idrivemirror.com/faq_virtualization",
    ibackup: "#",
    idrive: "https://www.idrive.com/mirror-image-backup-faq#virtualization"
  },
  diskFaq: {
    mirror: "https://www.idrivemirror.com/faq#disk-errors",
    ibackup: "#",
    idrive: "https://www.idrive.com/mirror-image-backup-faq#disk-errors"
  },
  massDeploy: {
    mirror: "https://www.idrivemirror.com/idrivemirror-gpo",
    ibackup: "#",
    idrive: "https://www.idrive.com/idrive-mirror-gpo"
  },
  errorCode: {
    mirror: "https://www.idrivemirror.com/error-code",
    ibackup: "#",
    idrive: "https://www.idrive.com/mirror-error-code"
  },
  origLocRestore: {
    mirror:
      "https://www.idrivemirror.com/faq_restore#restore-original-location",
    ibackup: "#",
    idrive:
      "https://www.idrive.com/mirror-image-backup-faq#restore-original-location"
  },
  rpcVirtualisationDomain: {
    idrive: "https://mirror.remotepc.com"
  },
  rpcVirtualizationUrl: {
    idrive: "https://mirror.remotepc.com/rpcnew/mirror/viewer/connect/"
  },
  rpcVirtualizationFaq: {
    idrive: "https://www.idrivemirror.com/high-performance-virtualization"
  }
};

export const WEEKDAYS = {
  "2": {
    key: "MONDAY",
    name: "Mon",
    code: 2,
    priority: 1
  },
  "3": {
    key: "TUESDAY",
    name: "Tue",
    code: 3,
    priority: 1
  },
  "4": {
    key: "WEDNESDAY",
    name: "Wed",
    code: 4,
    priority: 1
  },
  "5": {
    key: "THURSDAY",
    name: "Thu",
    code: 5,
    priority: 1
  },
  "6": {
    key: "FRIDAY",
    name: "Fri",
    code: 6,
    priority: 1
  },
  "7": {
    key: "SATURDAY",
    name: "Sat",
    code: 7,
    priority: 1
  },
  "1": {
    key: "SUNDAY",
    name: "Sun",
    code: 1,
    priority: 2
  }
};

export const CARD_BRANDS = {
  Visa: "visa",
  MasterCard: "master",
  ["American Express"]: "american amex",
  Discover: "discover",
  ["Diners Club"]: "diners",
  UnionPay: "unionpay",
  JCB: "jcb"
};

export const CLIENT_ERROR_CODES_TO_DISPLAY_KNOW_MORE = [
  200,
  217,
  218,
  219,
  220,
  221,
  222,
  223,
  224,
  225,
  226,
  227
];

export const PRIVATE_KEY = "Idrive@PrivateKey#@!";

export const VM_CONTROL_ACTIONS = {
  power_off: 5,
  power_on: 1,
  reboot: 1,
  delete: 6
};

export const VM_STATUS_ENUM = {
  0: "UNKNOWN",
  1: "ON",
  2: "BLOCKED",
  3: "PAUSED",
  4: "SHUTDOWN",
  5: "OFF",
  6: "CRASHED",
  7: "SUSPENDED",
  8: "DELETE_PENDING",
  9: "REBUILD_NEEDED",
  10: "IN_PROGRESS",
  11: "CREATED"
};

export const VM_NETWORK_SOURCE = {
  default: "NAT (Firewalled)",
  disconnected: "Disconnected",
  none: "Disconnected"
};

export const VM_STORAGE_TARGET_BUS = {
  sata: "SATA"
};

export const MEMORY_PLANS = ["basic16", "pro24", "pro32", "pro48", "pro64"];

export const VIRTUALIZATION_ERROR_MSGS = {
  BACKUP_DEVICE_NOT_FOUND:
    "Request could not be completed as the backup set does not exist",
  BACKUP_NOT_FOUND:
    "Request could not be completed as the backup set does not exist",
  CATALOG_DETAILS_NOT_FOUND:
    "Request could not be completed as the backup set does not exist",
  DATABASE_OPERATION_ERROR:
    "Request could not be completed as the backup set does not exist",
  DATASET_PATH_ERROR:
    "Request could not be completed as the backup set does not exist",
  DEVICE_DETAILS_NOT_FOUND:
    "Request could not be completed as the backup set does not exist",
  ENTITY_NOT_FOUND:
    "Request could not be completed as the backup set does not exist",
  HYPERVISOR_SERVER_ERROR:
    "Request could not be completed as the system encountered a hypervisor error.",
  HYPERVISOR_VIRTUAL_DISK_ERROR:
    "	Request could not be completed as the system encountered a hypervisor error.",
  STORAGE_SERVER_ERROR:
    "Request could not be completed as system encountered storage error",
  STORAGE_VIRTUAL_DISK_ERROR:
    "Request could not be completed as the backup set does not exist",
  VALIDATION_ERROR: "Unable to process your request at the moment. Try again",
  VM_CREATION_ERROR: "Unable to create virtual instance. Try again",
  default: "System encountered error during virtualization. Try again"
};

export const VIRTUALIZATION_WARNING_MSG = {
  shutdownMsg: {
    threshold: 10,
    finalDays: 14,
    msg: {
      part1: "This virtual instance will be shutdown automatically",
      part2:
        ", but will remain mounted with data preserved. To resume usage, you must manually power it on again."
    }
  },
  deleteMsg: {
    threshold: 14,
    finalDays: 21,
    msg: "This virtual instance will be deleted automatically"
  }
};

export const BackupWithWarnErrCodes = [219];

export const daysInMonth = {
  1: 31,
  2: 28,
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31
};
